<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <!-- <h1>退款</h1> -->
      <el-form :model="form"
               style="width: 100%"
               size="small"
               label-width="90px">
        <el-row :gutter="20">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="refund_id"
                            label="退款单号">
                <el-input v-model="form.refund_id"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="tid"
                            label="订单号">
                <el-input v-model="form.tid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="oid"
                            label="子订单号">
                <el-input v-model="form.oid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="reason"
                            label="退款原因">
                <!-- <el-input v-model="form.reason"></el-input> -->
                <el-select clearable
                           v-model="form.reason"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in refundreason"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="refund_status"
                            label="退款单状态">
                <!-- <el-input v-model="form.refund_status"></el-input> -->
                <!-- refundstatus -->
                <el-select clearable
                           v-model="form.refund_status"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in refundstatus"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="sku"
                            label="SKU">
                <el-input v-model="form.sku"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="100px"
                            prop="title"
                            label="商品标题">
                <el-input v-model="form.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="searchAreaStatus">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="100px"
                              prop="refund_time"
                              label="退款申请时间">
                  <!-- <el-input v-model="form.refund_time"></el-input> -->
                  <el-date-picker v-model="form.refund_time"
                                  type="datetimerange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="100px"
                              prop="update_time"
                              label="更新时间">
                  <!-- <el-input v-model="form.update_time"></el-input> -->
                  <el-date-picker v-model="form.update_time"
                                  type="datetimerange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-col :span="6">
              <el-form-item label-width="100px" prop="payment" label="支付总金额">
                <el-row class="no-margin">
                  <el-col :span="11">
                    <el-form-item prop="payment1" class="margin-bottom">
                      <el-input type="number" v-model.number="form.payment1"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="text-align: center;">~</el-col>
                  <el-col :span="11">
                    <el-form-item prop="payment2" class="margin-bottom">
                      <el-input type="number" v-model.number="form.payment2"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>-->
            <el-col :span="6">
              <el-form-item prop="trade_from"
                            label="平台">
                <el-select clearable
                           v-model="form.trade_from"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in tradefrom"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="platCode"
                            label="行业">
                <el-select clearable
                           v-model="form.profession"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in platlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="business"
                            label="商家">
                <el-select v-loading="ptnListLoading"
                           clearable
                           v-model="form.business"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in ptnlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="store"
                            label="店铺">
                <el-select v-loading="shopListLoading"
                           clearable
                           v-model="form.store"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in shoplists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
        <!-- <el-button @click="() =>this.$message.success({msg: 'sss', offset: 61})">xxx</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData">
      <el-table-column align="center"
                       header-align="center"
                       prop="refund_id"
                       label="退款单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="tid"
                       label="订单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="oid"
                       label="子订单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="title"
                       label="商品标题"
                       width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="sku"
                       label="SKU"
                       width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="reason"
                       label="退款原因"
                       width="180px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="refund_time"
                       label="退款申请时间"
                       width="160px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="good_status"
                       label="货物状态"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="refund_status"
                       label="退款单状态"
                       width="180px"></el-table-column>
      <!-- <el-table-column align="center" header-align="center" prop="payment" label="支付总金额" width="180px"></el-table-column> -->
      <el-table-column align="center"
                       header-align="center"
                       prop="refund_price"
                       label="退还金额"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="num"
                       label="数量"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="platform_from"
                       label="平台"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
  getrefundstatus,
  getrefundreason,
} from '@/common/mixins/select'
export default {
  mixins: [
    ActionLine,
    SearchMixin,
    getplatlists,
    getptnlists,
    getshoplists,
    gettradestatus,
    gettradefrom,
    handleExport,
    getrefundstatus,
    getrefundreason,
  ],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        Desc.refundLists_api,
        this.queryPrdlists
      )
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  .el-col >>> {
    .no-margin {
      .margin-bottom {
        margin-bottom: 0px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/base/refund/index.vue